import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'Transactions'
}

const fetchTransactions = new Action('fetchTransactions', {
  success: (data) => data,
})

const claimPendingTransactions = new Action('claimPendingTransactions', {
  init: (callback) => ({ callback }),
  success: (data) => data,
  failure: (error) => ({ error }),
})

export default {
  fetchTransactions,
  claimPendingTransactions,
}
